// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__AsMOf","dummyRightMenu":"styles_dummyRightMenu__2XkkC","imgSkeleton":"styles_imgSkeleton__2V3r-"};